import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReconnect = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4713 5.16402C12.6611 4.25856 11.5951 3.6204 10.4143 3.334C9.23354 3.04759 7.99362 3.12642 6.85861 3.56006C5.7236 3.9937 4.74699 4.76171 4.05798 5.7625C3.36898 6.76328 3.00005 7.94966 3 9.16469V9.66669",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.52856 13.166C5.33873 14.0714 6.40468 14.7095 7.5854 14.9959C8.76613 15.2824 10.006 15.2036 11.141 14.77C12.276 14.3365 13.2526 13.5686 13.9416 12.5679C14.6307 11.5672 14.9997 10.3809 14.9999 9.16596V8.66663",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 10.1647L15 8.66467L16.5 10.1647",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 8.16467L3 9.66467L1.5 8.16467",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgReconnect);
export default ForwardRef;
